/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { Button, Spin, Table, Tag, Dropdown, Popconfirm, Modal, List, Card, Checkbox, message } from "antd";
import {
  FilePdfOutlined,
  EditOutlined,
  DeleteOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { Bus, Eye } from "lucide-react";

import { ChevronLeft, Sparkles, Settings } from "lucide-react";

import dayjs from "dayjs";
import "dayjs/locale/es";

import useBuses from "../hooks/useBuses";
import usePassengers from "../hooks/usePassengers";

import ExcursionBusesFormModal from "./ExcursionBusesFormModal";
import PassengerForm from "./PassengerForm";
import AutoAssignBusesModal from "./AutoAssignBusesModal";
import useExcursions from "../hooks/useExcursions";
import useRequest from "../hooks/useRequest";

dayjs.locale("es");

function ExcursionBusesTable() {
  const { excursionId } = useParams();
  const navigate = useNavigate();

  const { getBusDetail, deleteBus, autoassignBuses, dealocateBuses, updateBus, optimizeBusHotelOrder } =
    useBuses();
  const { passengersByHotel, getPassengersByHotel, updatePassenger, loading: passengersLoading } = usePassengers();
  const { getExcursionDetail, excursionDetail, editScheduledExcursion } = useExcursions();
  const { request } = useRequest();

  const [selectedBus, setSelectedBus] = useState();
  const [isBusModalOpen, setIsBusModalOpen] = useState(false);
  const [busToEdit, setBusToEdit] = useState();
  const [buses, setBuses] = useState();

  // Estados para pasajeros en lista de espera
  const [passengersToAssign, setPassengersToAssign] = useState([]);
  const [isSelectBusModalOpen, setIsSelectBusModalOpen] = useState(false);
  const [isSelectPassengersModalOpen, setIsSelectPassengersModalOpen] = useState(false);
  const [currentHotelForSelection, setCurrentHotelForSelection] = useState(null);
  const [selectedPassengerIds, setSelectedPassengerIds] = useState([]);
  const [localPassengersByHotel, setLocalPassengersByHotel] = useState([]);
  const [passengerDetailModal, setPassengerDetailModal] = useState({ open: false, passenger: null });
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isAutoAssignModalOpen, setIsAutoAssignModalOpen] = useState(false);

  useEffect(() => {
    if (!excursionId) return;

    getExcursionDetail(excursionId);
    getPassengersByHotel({ scheduled_excursion: excursionId });
  }, [excursionId]);

  // Sincronizar estado local con datos del servidor
  useEffect(() => {
    if (passengersByHotel) {
      setLocalPassengersByHotel(passengersByHotel);
      setIsInitialLoad(false);

      // Actualizar el hotel seleccionado si está abierto el modal
      if (currentHotelForSelection) {
        const updatedHotel = passengersByHotel.find(
          h => h.hotel?.id === currentHotelForSelection.hotel?.id
        );
        if (updatedHotel) {
          setCurrentHotelForSelection(updatedHotel);
        }
      }
    }
  }, [passengersByHotel]);

  useEffect(() => {
    if (!excursionDetail) return;

    const busesArray = excursionDetail.buses || [];

    // Verificar si hay buses duplicados por ID (error de backend)
    const busIds = busesArray.map(b => b.id);
    const uniqueBusIds = new Set(busIds);
    if (busIds.length !== uniqueBusIds.size) {
      console.warn('⚠️ Buses duplicados por ID detectados del backend');
      // Filtrar solo duplicados por ID
      const uniqueBuses = Array.from(
        new Map(busesArray.map(bus => [bus.id, bus])).values()
      );
      setBuses(uniqueBuses);
    } else {
      setBuses(busesArray);
    }
  }, [excursionDetail]);

  const baseUrl = process.env.REACT_APP_API_URL;

  const columns = [
    {
      title: "Transportista",
      dataIndex: "busExcursion",
      key: "busExcursion",
      render: (busExcursion) => `${busExcursion?.bus.busSelectorName}`,
    },
    {
      title: "Butacas Ocupadas",
      key: "occupiedSeats",
      render: (_, record) => {
        const totalSeats = record.busExcursion?.bus?.seats || 0;
        const availableSeats = record.availableSeats || 0;
        return totalSeats - availableSeats;
      },
    },
    {
      title: "Butacas Disponibles",
      dataIndex: "availableSeats",
      key: "availableSeats",
    },
    {
      title: "Hotel de salida",
      dataIndex: "departureHotel",
      key: "departureHotel",
      render: (departureHotel) =>
        departureHotel ? (
          departureHotel.name
        ) : (
          <Tag color="warning" bordered={false}>
            No asignado
          </Tag>
        ),
    },
    {
      title: "Guía",
      dataIndex: "guide",
      key: "guide",
      render: (user) => `${user?.firstName} ${user?.lastName}`,
    },
    {
      title: "Observación",
      dataIndex: "observation",
      key: "observation",
      render: (observation) =>
        observation ? (
          <span className="text-gray-600 text-xs">{observation}</span>
        ) : (
          <span className="text-gray-400 text-xs">-</span>
        ),
    },
    {
      title: "",
      key: "actions",
      render: (text, record) => {
        const items = [
          {
            key: "export",
            label: (
              <div
                className="flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(
                    `${baseUrl}scheduled-excursions-buses/${record?.uuid}/pdf/`,
                    "_blank"
                  );
                }}
              >
                <FilePdfOutlined className="me-2" />
                <span>Exportar en PDF</span>
              </div>
            ),
          },
          {
            key: "whatsapp",
            label: (
              <div
                className="flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  const phone = record?.guide?.phone?.replace(/\D/g, "") || "";
                  const pdfUrl = `${baseUrl}scheduled-excursions-buses/${record?.uuid}/pdf/`;
                  const message = encodeURIComponent(`Hola! Te comparto el PDF del micro: ${pdfUrl}`);
                  window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
                }}
              >
                <WhatsAppOutlined className="me-2 text-green-500" />
                <span>Enviar PDF por WhatsApp</span>
              </div>
            ),
          },
          {
            key: "edit",
            label: (
              <div
                className="flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedBus(record);
                  setBusToEdit(record);
                  setIsBusModalOpen(true);
                }}
              >
                <EditOutlined className="me-2" />
                <span>Editar Micro</span>
              </div>
            ),
          },
          {
            key: "delete",
            danger: true,
            label: (
              <div
                className="flex items-center"
                onClick={async (e) => {
                  e.stopPropagation();
                  await deleteBus(record.id);
                  getExcursionDetail(excursionId);
                }}
              >
                <DeleteOutlined className="me-2" />
                <span>Borrar</span>
              </div>
            ),
          },
        ];

        return (
          <Dropdown menu={{ items }} trigger={["click"]}>
            {/* <Button type="link">Acciones</Button> */}
            <div className="flex justify-center" onClick={(e) => e.stopPropagation()}>
              <Settings className="hover:cursor-pointer" size={16} />
            </div>
          </Dropdown>
        );
      },
    },
  ];

  const handleOpenAutoAssignModal = () => {
    // Validar que existan micros creados
    if (!buses || buses.length === 0) {
      message.error("Debe crear al menos un micro antes de realizar el armado automatico");
      return;
    }

    // Validar que todos los micros tengan hotel de salida asignado
    const busesWithoutDepartureHotel = buses.filter(bus => !bus.departureHotel);
    if (busesWithoutDepartureHotel.length > 0) {
      const busNames = busesWithoutDepartureHotel
        .map(bus => bus.busExcursion?.bus?.busSelectorName || "Micro sin nombre")
        .join(", ");
      message.error(`Los siguientes micros no tienen hotel de salida asignado: ${busNames}`);
      return;
    }

    setIsAutoAssignModalOpen(true);
  };

  const handleAutoAssign = async () => {
    const response = await autoassignBuses(excursionId);
    await getExcursionDetail(excursionId);
    return response;
  };

  const handleUpdateExcursionCoordinates = async (coordinates) => {
    const excursionTypeId = excursionDetail?.excursionTypePrices?.excursionType?.id;
    if (!excursionTypeId) {
      message.error("No se pudo obtener el tipo de excursion");
      return;
    }

    await request(
      "PATCH",
      `excursion-types/${excursionTypeId}/`,
      () => {
        getExcursionDetail(excursionId);
      },
      (error) => {
        message.error("Error al actualizar coordenadas");
      },
      { coordinates }
    );
  };

  const handleUpdateBusDepartureHotel = async (busId, hotelId) => {
    await updateBus({
      id: busId,
      departureHotel: hotelId,
    });
    // Actualizar buses locales
    const updatedBus = await getBusDetail(busId);
    setBuses((prev) =>
      prev.map((bus) => (bus.id === busId ? updatedBus : bus))
    );
  };

  const handleOpenAddBusModal = () => {
    setIsBusModalOpen(true);
  };

  const handleAssignPassengersToBus = async (busId, passengers, onProgress) => {
    let completed = 0;
    for (const passenger of passengers) {
      await updatePassenger({
        id: passenger.id,
        scheduledExcursionBus: busId,
      });
      completed++;
      if (onProgress) onProgress(completed, passengers.length);
    }
    const updatedBus = await getBusDetail(busId);
    setBuses((prev) =>
      prev.map((bus) => (bus.id === busId ? updatedBus : bus))
    );
    refreshWaitingList();
  };

  const handleOptimizeRoute = async (busId) => {
    const result = await optimizeBusHotelOrder(busId);
    if (result && !result.error) {
      // Actualizar datos del micro
      const updatedBus = await getBusDetail(busId);
      setBuses((prev) =>
        prev.map((bus) => (bus.id === busId ? updatedBus : bus))
      );
    }
    return result;
  };

  const handleDealocateBuses = async () => {
    await dealocateBuses(excursionId);
    getExcursionDetail(excursionId);
    window.location.reload();
  };

  const handleDeleteBus = async (busId) => {
    await deleteBus(busId);
    await getPassengersByHotel({ scheduled_excursion: excursionId });
    await getExcursionDetail(excursionId);
  };

  const handleUnassignPassengers = async (passengers, onProgress) => {
    let completed = 0;
    for (const passenger of passengers) {
      await updatePassenger({
        id: passenger.id,
        scheduledExcursionBus: null,
      });
      completed++;
      if (onProgress) onProgress(completed, passengers.length);
    }
    await getPassengersByHotel({ scheduled_excursion: excursionId });
    await getExcursionDetail(excursionId);
  };

  const handleFinishExcursion = async () => {
    await editScheduledExcursion({
      id: excursionId,
      status: "FINISHED",
    });
    getExcursionDetail(excursionId);
  };

  // Funciones para asignación de pasajeros
  const refreshWaitingList = () => {
    getPassengersByHotel({ scheduled_excursion: excursionId });
    getExcursionDetail(excursionId);
  };

  const handleAssignPassengerToBus = async (busId) => {
    if (passengersToAssign.length > 0) {
      const assignedIds = passengersToAssign.map(p => p.id);

      // Actualización optimista - remover pasajeros inmediatamente de la UI
      setLocalPassengersByHotel(prev =>
        prev.map(hotelGroup => ({
          ...hotelGroup,
          passengers: hotelGroup.passengers?.filter(p => !assignedIds.includes(p.id)) || []
        })).filter(hotelGroup => hotelGroup.passengers?.length > 0)
      );

      setIsSelectBusModalOpen(false);
      setPassengersToAssign([]);
      setSelectedPassengerIds([]);

      // Asignar en el servidor
      for (const passenger of passengersToAssign) {
        await updatePassenger({
          id: passenger.id,
          scheduledExcursionBus: busId,
        });
      }

      // Actualizar el bus específico que fue modificado
      const updatedBus = await getBusDetail(busId);
      setBuses((prev) =>
        prev.map((bus) => (bus.id === busId ? updatedBus : bus))
      );

      // Solo actualizar el detalle de la excursión para el contador de pasajeros pendientes
      getExcursionDetail(excursionId);
    }
  };

  // Abrir modal para seleccionar pasajeros de un hotel (todos seleccionados por defecto)
  const handleOpenSelectPassengersModal = (hotel) => {
    if (!buses || buses.length === 0) {
      message.warning("No hay micros");
      return;
    }
    setCurrentHotelForSelection(hotel);
    setSelectedPassengerIds(hotel.passengers?.map(p => p.id) || []);
    setIsSelectPassengersModalOpen(true);
  };

  // Continuar al modal de selección de bus con los pasajeros seleccionados
  const handleContinueToSelectBus = () => {
    const selectedPassengers = currentHotelForSelection?.passengers?.filter(
      (p) => selectedPassengerIds.includes(p.id)
    ) || [];
    setPassengersToAssign(selectedPassengers);
    setIsSelectPassengersModalOpen(false);
    setIsSelectBusModalOpen(true);
  };

  return (
    <>
      {!excursionDetail ? (
        <Spin fullscreen />
      ) : (
        <div className="">
          <div className="flex justify-between mb-3">
            <div className="flex">
              <Button
                type="text"
                onClick={() => {
                  navigate(-1);
                }}
                icon={<ChevronLeft size={16} />}
              >
                Volver
              </Button>
            </div>

            <span className="font-semibold text-lg">
              {`Micros - ${excursionDetail.excursionType?.name || 'Sin tipo'} (${dayjs(
                excursionDetail.day
              ).format("ddd DD MMM")})`}
            </span>

            <div className="flex">
            <Button
                className="ms-3"
                type="secondary"
                onClick={() => {
                  window.open(
                    `${baseUrl}scheduled-excursions/${excursionId}/download-quantities/`,
                    '_blank'
                  );
                }}
              >
                Descargar cantidades
              </Button>

              <Button
                className="ms-3"
                color="purple"
                variant="solid"
                onClick={handleOpenAutoAssignModal}
              >
                Armado automatico de micros
                <Sparkles size={16} />
              </Button>

              <Button
                className="ms-3"
                type={"primary"}
                onClick={() => setIsBusModalOpen(true)}
              >
                Agregar micro
              </Button>
            </div>

            <ExcursionBusesFormModal
              selectedExcursion={excursionDetail}
              isOpen={isBusModalOpen}
              onClose={() => {
                setIsBusModalOpen(false);
                setBusToEdit(null);

                getExcursionDetail(excursionId);
              }}
              busToEdit={busToEdit}
              selectedBus={selectedBus}
              onCreate={() => {}}
            />
          </div>

          <div className="flex justify-between">
            <Tag
              color={
                excursionDetail.noBusAssignmentPassengerCount > 0
                  ? "warning"
                  : "success"
              }
              className="flex items-center justify-center w-1/3 my-2 font-bold"
            >
              {excursionDetail.noBusAssignmentPassengerCount > 0
                ? `${excursionDetail.noBusAssignmentPassengerCount} pasajeros pendientes`
                : "Sin pasajeros pendientes"}
            </Tag>

            <Popconfirm
              title="¿Estás seguro de desasignar todos los pasajeros?"
              onConfirm={handleDealocateBuses}
              okText="Sí"
              cancelText="No"
            >
              <Button variant="filled" color="danger">
                Desasignar todos pasajeros
              </Button>
            </Popconfirm>
          </div>

          {/* Sección de pasajeros en lista de espera */}
          {((isInitialLoad && passengersLoading.get) || localPassengersByHotel?.length > 0) && (
            <Card className="mb-4" title="Asignar pasajeros a micros" loading={isInitialLoad && passengersLoading.get}>
              <div className="flex gap-6">
                {Object.entries(
                  // Paso 1: Agrupar por hotel (uniendo grupos del mismo hotel)
                  Object.values(
                    (localPassengersByHotel || []).reduce((acc, item) => {
                      const hotelId = item.hotel?.id;
                      if (!hotelId) return acc;

                      if (!acc[hotelId]) {
                        acc[hotelId] = {
                          hotel: item.hotel,
                          groups: [],
                          allPassengers: []
                        };
                      }
                      acc[hotelId].groups.push({
                        group: item.group,
                        passengers: item.passengers
                      });
                      acc[hotelId].allPassengers = [
                        ...acc[hotelId].allPassengers,
                        ...(item.passengers || [])
                      ];
                      return acc;
                    }, {})
                  )
                  // Paso 2: Agrupar por zona
                  .reduce((acc, hotelData) => {
                    const zone = hotelData.hotel?.zones || "Sin zona";
                    if (!acc[zone]) acc[zone] = [];
                    acc[zone].push(hotelData);
                    return acc;
                  }, {})
                )
                .sort(([a], [b]) => {
                  const order = ["Perla", "Centro", "Aldrey"];
                  const indexA = order.findIndex(z => a.toLowerCase().includes(z.toLowerCase()));
                  const indexB = order.findIndex(z => b.toLowerCase().includes(z.toLowerCase()));
                  return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
                })
                .map(([zone, hotels]) => (
                  <div key={zone} className="flex-1">
                    <div className="font-semibold text-gray-700 mb-2 pb-1 border-b">
                      {zone}
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                      {hotels.map((hotelData) => (
                        <div
                          key={hotelData.hotel?.id}
                          className="p-2 rounded border border-gray-200 hover:border-blue-400 hover:bg-blue-50 transition-colors cursor-pointer"
                          onClick={() => handleOpenSelectPassengersModal({
                            hotel: hotelData.hotel,
                            group: hotelData.groups[0]?.group,
                            passengers: hotelData.allPassengers
                          })}
                        >
                          <div className="flex justify-between items-center">
                            <span className="font-medium text-sm truncate">
                              {hotelData.hotel?.name}
                            </span>
                            <Tag color="blue" className="ml-1">
                              {hotelData.allPassengers?.reduce((sum, p) =>
                                sum + (p.adjustedAdultsCount || 0) + (p.adjustedMinorsCount || 0) +
                                (p.adjustedHalfPriceAdultsCount || 0) + (p.adjustedFreeCount || 0), 0
                              ) || 0}
                            </Tag>
                          </div>
                          <div className="text-xs text-gray-400 mt-1">
                            {hotelData.groups.map((g, idx) => (
                              <div key={idx} className="truncate">
                                {g.group?.company?.name || ''} - {g.passengers?.reduce((sum, p) =>
                                  sum + (p.adjustedAdultsCount || 0) + (p.adjustedMinorsCount || 0) +
                                  (p.adjustedHalfPriceAdultsCount || 0) + (p.adjustedFreeCount || 0), 0
                                ) || 0}
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          )}

          <Table
            columns={columns}
            dataSource={buses}
            loading={!buses}
            rowKey="id"
            onRow={(record) => ({
              onClick: () => {
                navigate(`/excursiones/${excursionId}/buses/${record.id}`);
              },
              className: "cursor-pointer hover:bg-blue-50",
            })}
          />

          {/* Botón finalizar excursión */}
          <div className="flex justify-end mt-4">
            <Popconfirm
              title="¿Estás seguro de finalizar esta excursión?"
              description="Esta acción cambiará el estado de la excursión a FINALIZADA"
              onConfirm={handleFinishExcursion}
              okText="Sí, finalizar"
              cancelText="Cancelar"
            >
              <Button
                type="primary"
                size="large"
                disabled={excursionDetail?.status === "FINISHED"}
              >
                {excursionDetail?.status === "FINISHED" ? "Excursión finalizada" : "Finalizar excursión"}
              </Button>
            </Popconfirm>
          </div>

          {/* Modal para seleccionar pasajeros de un hotel */}
          <Modal
            title={`Seleccionar pasajeros - ${currentHotelForSelection?.hotel?.name}`}
            open={isSelectPassengersModalOpen}
            onCancel={() => {
              setIsSelectPassengersModalOpen(false);
              setCurrentHotelForSelection(null);
              setSelectedPassengerIds([]);
              refreshWaitingList();
            }}
            footer={
              <div className="flex justify-end gap-2">
                <Button onClick={() => {
                    setIsSelectPassengersModalOpen(false);
                    setCurrentHotelForSelection(null);
                    setSelectedPassengerIds([]);
                    refreshWaitingList();
                  }}>
                  Cancelar
                </Button>
                <Button
                  type="primary"
                  disabled={selectedPassengerIds.length === 0}
                  onClick={handleContinueToSelectBus}
                >
                  Continuar ({selectedPassengerIds.length} seleccionados)
                </Button>
              </div>
            }
            width={600}
          >
            <div className="mb-3">
              <Checkbox
                checked={selectedPassengerIds.length === currentHotelForSelection?.passengers?.length}
                indeterminate={selectedPassengerIds.length > 0 && selectedPassengerIds.length < currentHotelForSelection?.passengers?.length}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedPassengerIds(currentHotelForSelection?.passengers?.map(p => p.id) || []);
                  } else {
                    setSelectedPassengerIds([]);
                  }
                }}
              >
                Seleccionar todos
              </Checkbox>
            </div>
            <List
              dataSource={currentHotelForSelection?.passengers || []}
              renderItem={(passenger) => (
                <List.Item className="py-2">
                  <div className="flex items-center justify-between w-full">
                    <Checkbox
                      checked={selectedPassengerIds.includes(passenger.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedPassengerIds([...selectedPassengerIds, passenger.id]);
                        } else {
                          setSelectedPassengerIds(selectedPassengerIds.filter(id => id !== passenger.id));
                        }
                      }}
                    >
                      <div className="flex items-center gap-4 ml-2">
                        <div className="flex flex-col">
                          <span className="font-medium">{passenger.name}</span>
                          <span className="text-xs text-gray-400">{currentHotelForSelection?.group?.company?.name || ''}</span>
                        </div>
                        <div className="flex gap-3 text-xs text-gray-600">
                          <span>A: {passenger.adjustedAdultsCount || 0}</span>
                          <span>M: {passenger.adjustedMinorsCount || 0}</span>
                          <span>L: {passenger.adjustedFreeCount || 0}</span>
                        </div>
                      </div>
                    </Checkbox>
                    <Button
                      type="text"
                      size="small"
                      icon={<Eye size={16} />}
                      onClick={(e) => {
                        e.stopPropagation();
                        setPassengerDetailModal({ open: true, passenger });
                      }}
                    >
                      Ver detalle
                    </Button>
                  </div>
                </List.Item>
              )}
            />
          </Modal>

          {/* Modal de detalle del pasajero */}
          <Modal
            title="Detalle de Pasajero"
            open={passengerDetailModal.open}
            onCancel={async () => {
              setPassengerDetailModal({ open: false, passenger: null });
              // Refrescar datos y actualizar el hotel actual
              await getPassengersByHotel({ scheduled_excursion: excursionId });
              getExcursionDetail(excursionId);
            }}
            footer={null}
            width={1000}
            destroyOnClose
          >
            {passengerDetailModal.passenger?.id && (
              <PassengerForm
                passengerId={passengerDetailModal.passenger.id}
                isModal={true}
                onSuccess={() => {
                  setPassengerDetailModal({ open: false, passenger: null });
                  refreshWaitingList();
                }}
              />
            )}
          </Modal>

          {/* Modal para seleccionar micro */}
          <Modal
            title={`Asignar ${passengersToAssign.length} pasajero${passengersToAssign.length > 1 ? 's' : ''}`}
            open={isSelectBusModalOpen}
            onCancel={() => {
              setIsSelectBusModalOpen(false);
              setPassengersToAssign([]);
              refreshWaitingList();
            }}
            footer={null}
            width={500}
          >
            <p className="mb-4 text-gray-600">Selecciona el micro destino:</p>
            <List
              dataSource={buses || []}
              locale={{ emptyText: "No hay micros disponibles" }}
              renderItem={(bus) => (
                <List.Item
                  className="cursor-pointer hover:bg-blue-50 transition-colors duration-150"
                  onClick={() => handleAssignPassengerToBus(bus.id)}
                >
                  <div className="flex items-center gap-3 w-full">
                    <Bus size={20} className="text-gray-500" />
                    <div className="flex flex-col flex-1">
                      <span className="font-medium">
                        {bus.busExcursion?.bus?.busSelectorName}
                      </span>
                      <span className="text-xs text-gray-500">
                        Guía: {bus.guide?.firstName} {bus.guide?.lastName}
                      </span>
                    </div>
                    <Tag color={bus.availableSeats > 0 ? "success" : "error"}>
                      {bus.availableSeats} asientos libres
                    </Tag>
                  </div>
                </List.Item>
              )}
            />
          </Modal>

          {/* Modal de armado automatico de micros */}
          <AutoAssignBusesModal
            isOpen={isAutoAssignModalOpen}
            onClose={() => setIsAutoAssignModalOpen(false)}
            excursionDetail={excursionDetail}
            buses={buses}
            passengersByHotel={localPassengersByHotel}
            onAutoAssign={handleAutoAssign}
            onUpdateExcursionCoordinates={handleUpdateExcursionCoordinates}
            onUpdateBusDepartureHotel={handleUpdateBusDepartureHotel}
            onOpenAddBusModal={handleOpenAddBusModal}
            onAssignPassengersToBus={handleAssignPassengersToBus}
            onOptimizeRoute={handleOptimizeRoute}
            onUnassignAllPassengers={handleDealocateBuses}
            onUnassignPassengers={handleUnassignPassengers}
            onDeleteBus={handleDeleteBus}
            onRefresh={refreshWaitingList}
          />
        </div>
      )}
    </>
  );
}

export default ExcursionBusesTable;
